import {
  format,
  parseISO,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  addDays,
  subDays,
  isSameDay,
  getDay,
  differenceInHours,
  startOfMonth,
  endOfMonth,
  addMonths,
  subMonths,
  isBefore,
  addHours,
} from 'date-fns';

export const formatDateRange = (startDate: Date, endDate?: Date): string => {
  const finalEndDate = endDate || addDays(startDate, 6);
  return `${format(startDate, 'MMM d')} to ${format(finalEndDate, 'MMM d, yyyy')}`;
};

export const formatShiftTime = (isoString: string): string => {
  if (!isoString) return '';
  try {
    return format(parseISO(isoString), 'h:mm a'); // 12-hour format with AM/PM
  } catch (error) {
    return "Invalid Time";
  }
};

// Export addHours for use in other components
export { addHours };

export const formatShiftDateTime = (isoString: string): string => {
  if (!isoString) return '';
  try {
    return format(parseISO(isoString), "MMM d, h:mm a");
  } catch (error) {
    return "Invalid Date";
  }
};

export const formatShiftDetailTimeRange = (startTime: string, endTime: string): string => {
  if (!startTime || !endTime) return 'N/A';
  try {
    const start = parseISO(startTime);
    const end = parseISO(endTime);
    return `${format(start, 'h:mm a')} - ${format(end, 'h:mm a')}`; // Ensure 12-hour format with AM/PM
  } catch (error) {
    return "Invalid Time Range";
  }
};

export const getDaysOfWeek = (currentDate: Date): Date[] => {
  const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 });
  return eachDayOfInterval({ start: weekStart, end: addDays(weekStart, 6) });
};

export const getDayAbr = (date: Date): string => format(date, 'E'); 
export const getDayNumber = (date: Date): string => format(date, 'd'); 

// Re-export date-fns functions
export {
  parseISO,
  format,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  addDays,
  subDays,
  isSameDay,
  getDay,
  differenceInHours,
  startOfMonth,
  endOfMonth,
  addMonths,
  subMonths,
  isBefore,
};